<div>
    <button id="id_dashboard_adv_filter" type="button" class="btn btn-sm btn-action btn-light"
        [class.changed]="_isFilterApplied" data-toggle="modal" data-target="#advFilterModalHost" [disabled]="!_isReady"
        (click)="openAdvanceFilter()">
        Advanced filter
    </button>
</div>
<div id="advFilterModalHost" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <ng-template dev-saved-filter-func></ng-template>
</div>